var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#E1EFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#4D68A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40114 5.28888C4.77002 5.88868 4.77002 6.88834 4.77002 8.85133V9.21484C4.77002 11.196 4.77002 12.1775 5.40114 12.7955C6.01371 13.3953 7.03464 13.3953 9.03939 13.3953H9.41064C11.434 13.3953 12.4363 13.3953 13.0675 12.7773C13.68 12.1775 13.68 11.1778 13.68 9.21484V8.85133C13.68 6.87017 13.68 5.88868 13.0489 5.2707C12.4363 4.6709 11.4154 4.6709 9.41064 4.6709H9.03939C7.03464 4.6709 6.01371 4.6709 5.40114 5.28888ZM6.27358 7.32456C6.32927 9.59654 7.48014 10.9597 9.50346 10.9597H9.61483V9.66924C10.3573 9.74194 10.9328 10.269 11.1555 10.9597H12.2136C11.9166 9.9237 11.1555 9.36025 10.6915 9.14214C11.1741 8.8695 11.8423 8.21518 11.9908 7.32456H11.0256C10.8214 8.05159 10.2088 8.70592 9.61483 8.76045V7.32456H8.66814V9.83282C8.07414 9.68742 7.33164 8.97856 7.29452 7.32456H6.27358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.6f7dccc540351c0f9f6ff0dc9c3503b6.svg";
export { ForwardRef as ReactComponent };